import req from '../../api/request'
import type { EventPayload, SnEvent } from '../../features/event/types'
import type { EventSeriesScope } from '../../features/event/seriesScope'

/**
 * Update an existing event.
 *
 * `scope` applies only to a recurring event: 'this' edits the single
 * occurrence, 'following' edits it and everything after it, 'all' edits the
 * whole series. Omitted for a one-off, so a plain edit sends no query string
 * at all — the endpoint's own default.
 */
export const updateEvent = async (
  eventId: string,
  payload: EventPayload,
  scope?: EventSeriesScope
): Promise<SnEvent> => {
  const response = await req(`/events/${eventId}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
    ...(scope ? { query: { scope } } : {}),
  })
  return response.data as SnEvent
}
